const de = {
    menu_home: "Home page",
    menu_SpeRetrieve: "special query",
    menu_CLCRetrieve: "Chinese Library Classification query",
    menu_AdvanceRetrieve: "advanced retrieval",
    menu_BookMarkRetrieve: "bookmark retrieval",
    menu_Notes: "Informationsmitteilung",
    menu_Mylibray: "Meine Bibliothek",

    field_hit: 'hits',
    field_author: 'Verantwortliche Person',
    field_pubdate: 'publication time',
    field_content: 'Serienname',
    field_pages: 'Anzahl der Seiten',
    field_publisher: 'Verlag',
    field_clcno: 'Klassifizierungsnummer',
    field_price: 'Preis',

    field_title: 'title',
    field_callno: 'Rufnummer',
    field_subject: 'Betreff Wort',
    field_pubyear: 'Jahr der Veröffentlichung',
    field_anyword: "any word",

    field_frontMatch: "Die Front ist konsistent",
    field_exactMatch: "exact match",
    field_fuzzyRetrieve: "fuzzy retrieval",

    field_labelOrder: "sort orde",
    field_orderAsc: "aufsteigende Ordnung",
    field_orderDesc: "absteigende Reihenfolge",

    field_tipInputKeyword: "please enter the keyword you want to search",
    field_retrieve: "abrufen",
    field_retrieveInReult: "retrieve in result",

    field_recordsPerPage: "display per page"
};

export default de;